import $ from 'jquery';
import { getPropertyHtml } from 'scripts/renderings/property-rendering';

export const init = (model) => {
  const $container = $('#' + model.containerId);
  const $button = $('#' + model.buttonId);
  let startIndex = 0;
  let totalPosition = 1;
  const numberOfPropertiesToLoad = 9;

  const loadMore = (labels, properties) => {
    let totalNumberOfPropertiesToShow = startIndex + numberOfPropertiesToLoad;
    if (totalNumberOfPropertiesToShow >= properties.length) {
      totalNumberOfPropertiesToShow = properties.length;
      $button.hide();
    } else {
      $button.show();
    }

    for (let i = startIndex; i < totalNumberOfPropertiesToShow; i++) {
      const property = getPropertyHtml(labels, properties[i]);
      if (model.oddMarkup && model.oddMarkupPlacement && totalPosition === model.oddMarkupPlacement) {
        $container.append(model.oddMarkup);
      } else if (properties.length < model.oddMarkupPlacement && totalPosition === totalNumberOfPropertiesToShow) { // Position given, or always before last property
        $container.append(model.oddMarkup);
      }
      $container.append(property);
      if (properties[i].Sold) {
        $container.find('article').last().addClass('sold');
      }
      totalPosition++;
    }

    startIndex += numberOfPropertiesToLoad;
  };

  $container.empty();
  loadMore(model.labels, model.properties);

  $button.on('click', (e) => {
    e.preventDefault();

    loadMore(model.labels, model.properties);
  });
};
